import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutCarrierRateList } from "./autogen/AutogenLayoutCarrierRateList";

export class CarrierRateList extends AutogenLayoutCarrierRateList {

    onLoad(): void | Promise<void> {
        this.tableCarrierRate.addButtonCaption = "Add Carrier Rate";
    }

    sourceCarrierRateBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.target_rate = 'N';
    }
    
}
